/**
 * Formata um valor string representando um número de gigabytes.
 *
 * - Se o valor não for uma string, retorna-o sem alterações.
 * - Se for uma string numérica, converte para número e formata com sufixo "GBs".
 * - Remove casas decimais desnecessárias se o número for inteiro.
 *
 * @param {string} value - Valor em string representando gigabytes (ex: "40.00").
 * @returns {string} Valor formatado como GBs (ex: "40 GBs"), ou valor original se inválido.
 */
export const formatGbs = (value: string): string => {
  if (typeof value !== "string") return value;

  const numeric = parseFloat(value);

  if (isNaN(numeric)) return value;

  const formatted = Number.isInteger(numeric)
    ? `${numeric}`
    : numeric.toFixed(2);

  return `${formatted} GBs`;
};
